export const LOGIN_URL = '/login';
export const RECOVERY_PASSWORD_URL = '/recovery-password';
export const EFFICIENCY_TESTS_INDEX_URL = '/efficiency-tests';
export const PUMPS_INDEX_URL = '/pumps';
export const DIAMETERS_INDEX_URL = '/diameters';
export const USERS_INDEX_URL = '/users';
